import { classNames } from "@/react/helpers/twMergeWithCN";
import { useProfileLinkProps } from "@circle-react/hooks/profile/useProfileLinkProps";
import type { CommunityMember } from "@circle-react/types";
import { Typography } from "@circle-react-uikit/Typography";
import { ConnectionButtons } from "../ActionButtons/ConnectionButtons";
import { MemberCardImageWithConnection } from "./MemberCardImageWithConnection";

export interface MemberCardWithConnectionProps {
  member: CommunityMember;
}

export const MemberCardWithConnection = ({
  member,
}: MemberCardWithConnectionProps) => {
  const profileLinkProps = useProfileLinkProps({
    public_uid: member.public_uid ?? "",
  });

  return (
    <li
      className={classNames(
        "bg-primary border-primary hover:shadow-c-card rounded-2xl border",
      )}
      data-testid="community_member_grid"
    >
      <div className="flex h-full flex-col justify-between gap-4 p-4">
        <a
          {...profileLinkProps}
          className="flex flex-col justify-between gap-4"
          title={member.name}
        >
          <div className="flex flex-col gap-4">
            <div style={{ aspectRatio: "1 / 1", height: "12.5rem" }}>
              <MemberCardImageWithConnection
                name={member.name ?? ""}
                src={member.avatar_url ?? ""}
              />
            </div>
            <div className="flex flex-col">
              <Typography.BodySm
                truncate
                color="text-dark"
                as="h2"
                weight="font-medium"
              >
                {member.name}
              </Typography.BodySm>
              <Typography.BodySm
                truncate
                weight="font-medium"
                color="text-light"
              >
                {member.headline}
              </Typography.BodySm>
            </div>
          </div>
        </a>
        <ConnectionButtons member={member} className="w-full" />
      </div>
    </li>
  );
};
